import { jsx as _jsx } from "react/jsx-runtime";
import legalDocuments from '@phishtool/legal-documents';
import Legal from '~components/legal';
const ServiceAgreement = () => _jsx(Legal, { heading: "Service Agreement", content: legalDocuments.serviceAgreement });
export default ServiceAgreement;
